/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressDto } from './addressDto';


export interface PaymentAccountSimpleDto { 
    id?: number;
    insertTs: string;
    fakturaCustomerRefNo: number;
    accountNumber: number;
    invoiceAddress?: AddressDto;
    accountName: string;
    currency: PaymentAccountSimpleDto.CurrencyEnum;
    preferredPaymentMethod?: PaymentAccountSimpleDto.PreferredPaymentMethodEnum;
    internalComment?: string;
    active: boolean;
    confirmed: boolean;
}
export namespace PaymentAccountSimpleDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const PreferredPaymentMethodEnum = {
        CreditCard: 'CREDIT_CARD',
        BankTransfer: 'BANK_TRANSFER'
    } as const;
    export type PreferredPaymentMethodEnum = typeof PreferredPaymentMethodEnum[keyof typeof PreferredPaymentMethodEnum];
}


